import { LogotypesJson, LogotypesDisplay } from '../../empracoTypes';
import { LogotypesGrid } from './logotypesGrid';
import { LogotypesSlideshow } from './logotypesSlideshow';

export interface LogotypesProps {
  data: LogotypesJson;
}

export function slidesPerView(setting: number | undefined) {
  if (!setting && setting === 0) {
    return 1;
  }

  if (!setting) {
    return 5;
  }

  if (setting > 12) {
    return 12;
  }

  if (setting < 1) {
    return 1;
  }

  return setting;
};

export default function Logotypes(props: LogotypesProps) {
  const { mediaObjects, display } = props.data;

  if (!mediaObjects) {
    return null;
  }

  if (display === LogotypesDisplay.grid || display === LogotypesDisplay.partiallyHiddenGrid) {
    return <LogotypesGrid data={props.data} />;
  }

  return <LogotypesSlideshow data={props.data} />;
}